var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInCommsSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconInCommsSetting_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 282",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h60v60H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconInCommsSetting_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 337",
    fill: "none",
    d: "M0 0h60v60H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "IconInCommsSetting",
    clipPath: "url(#IconInCommsSetting_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 341",
    fill: "#040000",
    clipPath: "url(#IconInCommsSetting_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 357",
    d: "M18.235 18.653a1.246 1.246 0 110 1.763 1.246 1.246 0 010-1.763"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 358",
    d: "M18.399 5.373A12.912 12.912 0 005.008 18.761a.755.755 0 001.51-.053A11.4 11.4 0 0118.342 6.883a.755.755 0 10.053-1.51"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 359",
    d: "M18.64 9.54a9.244 9.244 0 00-9.465 9.465.756.756 0 101.511-.006 7.735 7.735 0 017.948-7.948.756.756 0 10.006-1.511"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 360",
    d: "M18.714 13.89a5.45 5.45 0 00-3.716 1.484l-.038.038a5.451 5.451 0 00-1.483 3.716.757.757 0 001.513.008 3.943 3.943 0 011.041-2.655l.039-.039a3.947 3.947 0 012.655-1.041.756.756 0 10-.007-1.511"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 361",
    d: "M24.39 20.333v11.014a5.517 5.517 0 00-2.173-.44c-2.437 0-4.346 1.431-4.346 3.259s1.909 3.26 4.346 3.26 4.346-1.432 4.346-3.26v-7.8l8.692-1.739v4.547a5.515 5.515 0 00-2.173-.44c-2.437 0-4.346 1.432-4.346 3.26s1.909 3.26 4.346 3.26 4.346-1.431 4.346-3.26v-14.27z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 362",
    d: "M24.389 39.6h-2.173a4.351 4.351 0 01-4.346 4.346v2.173a4.351 4.351 0 014.346 4.346h2.173a4.351 4.351 0 014.346-4.346v-2.173a4.351 4.351 0 01-4.346-4.346"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 363",
    d: "M43.947 28.734h2.173a2.176 2.176 0 012.173-2.173v-2.175a2.176 2.176 0 01-2.173-2.173h-2.173a2.176 2.176 0 01-2.173 2.173v2.173a2.176 2.176 0 012.173 2.173"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 334",
    d: "M28.735 37.427h2.173V39.6h-2.173z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 335",
    d: "M33.082 41.773h2.173v2.173h-2.173z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 336",
    d: "M39.601 28.735h2.173v2.173h-2.173z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 364",
    d: "M39.601 33.248v13.763a6.292 6.292 0 00-3.259-.892c-3 0-5.433 1.949-5.433 4.346s2.437 4.346 5.433 4.346 5.432-1.949 5.432-4.346v-8.854l11.01-1.818v5.045a6.291 6.291 0 00-3.259-.891c-3 0-5.433 1.949-5.433 4.346s2.437 4.346 5.433 4.346 5.433-1.949 5.433-4.346V30.712z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInCommsSetting);
export default __webpack_public_path__ + "static/media/IconInCommsSetting.271a7b02d985fb89.svg";
export { ForwardRef as ReactComponent };